import { select } from 'redux-saga/effects';
import { ApplicationState } from './store.inteface';

export function* appSelect<TSelected>(
  selector: (state: ApplicationState) => TSelected,
): Generator<any, TSelected, TSelected> {
  return yield select(selector);
}
